import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Share from '../share';
import errorBoundary from '@ifeng/errorBoundary';

class ShareIconBox extends React.PureComponent {
    static propTypes = { docData: PropTypes.object };

    // share组件存在两个问题：hover 微信的图标二维码；hover 分享图标变红；顶部横线；图片圆框；
    state = {
        isShow: false,
    };

    handleMouseOver = () => {
        this.setState({ isShow: true });
    };

    handleMouseLeave = () => {
        this.setState({ isShow: false });
    };

    showCode = () => {
        this.setState({ wxShow: true });
    };

    hidCode = () => {
        this.setState({ wxShow: false });
    };

    /**
     * 渲染网页布局
     */

    render() {
        const { isShow } = this.state;
        const { docData } = this.props;
        const { title, summary, url, commentUrl, imagesInContent } = docData;
        const config = {
            items: ['sina', 'qqzone', 'wechat'],
            display: 'hover',
            hover: 'hover',
            type: 'horizontal',
            methods: 'hover',
            tooltip: 'bottom',
        };
        const shareInfo = {
            url,
            title,
            summary,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        return (
            <li className={styles.titshare} onMouseOver={this.handleMouseOver} onMouseLeave={this.handleMouseLeave}>
                <div className={isShow ? styles.shareBox : styles.boxhidden}>
                    <Share config={config} shareInfo={shareInfo} />
                </div>
            </li>
        );
    }
}

export default errorBoundary(ShareIconBox);
